export default __webpack_public_path__ + "static/media/banner-6.95eda840.png";